import React from 'react';
import PageLayout from '../../PageLayout.js';
import styles from './layout.module.css';

const Layout=(props)=> {  
	let content=[];
	for(let i=0;i<props.children.length;i+=4){
		let children=[];
		for(let j=0;j<4;j++)
			if(props.children.length>i+j)
				children.push(props.children[i+j]);
		content.push(<div className={styles.container}><PageLayout layout="HORIZONTAL4" sort={false} increment={0}>{children}</PageLayout></div>);
	}
	return (<div>{content}</div>);
}

export default Layout